import { takeEvery, call, put } from "redux-saga/effects";
import {
  FETCH_LIBRARY_CARDS_REQUEST,
  CREATE_LIBRARY_CARD_REQUEST,
  UPDATE_LIBRARY_CARD_REQUEST,
  GET_LIBRARY_CARD_REQUEST,
  DELETE_LIBRARY_CARD_REQUEST,
  GET_LIBRARY_CARD_TAGS_REQUEST,
  REQUEST_PRESIGNED_URL,
  UPLOAD_FILE_REQUEST,
  FETCH_METADATA_REQUEST,
  LIST_CARDS_REQUEST,
  FETCH_CARD_DETAILS_REQUEST,
  LIST_ENTITY_CARDS_REQUEST,
  fetchLibraryCardsSuccess,
  fetchLibraryCardsFailure,
  createLibraryCardSuccess,
  createLibraryCardFailure,
  updateLibraryCardSuccess,
  updateLibraryCardFailure,
  deleteLibraryCardSuccess,
  deleteLibraryCardFailure,
  presignedUrlSuccess,
  presignedUrlFailure,
  uploadFileSuccess,
  uploadFileFailure,
  fetchMetadataSuccess,
  fetchMetadataFailure,
  listCardsSuccess,
  listCardsFailure,
  fetchCardDetailsSuccess,
  fetchCardDetailsFailure,
  getLibraryCardTagsSuccess,
  getLibraryCardTagsFailure,
  listEntityCardsSuccess,
  listEntityCardsFailure,
} from "../actions/libraryCardActions";
import {
  fetchLibraryCardsFromApi,
  createLibraryCardInApi,
  updateLibraryCardInApi,
  deleteLibraryCardFromApi,
  fetchPresignedUrlsFromApi,
  uploadFileToApi,
  fetchMetadataFromApi,
  listLibraryCardsFromApi,
  fetchLibraryCardDetailsFromApi,
  getLibraryCardTagsApi,
} from "../apis/libraryCardApi";
import { getTenantId } from "../utils/authUtils";

// Saga to handle fetching LibraryCards
function* fetchLibraryCardsSaga(action) {
  try {
    const libraryCards = yield call(fetchLibraryCardsFromApi, action.payload);
    yield put(fetchLibraryCardsSuccess(libraryCards));
  } catch (error) {
    console.error("Error fetching LibraryCards:", error);
    yield put(fetchLibraryCardsFailure(error));
  }
}

// Saga to handle creating a new LibraryCard
function* createLibraryCardSaga(action) {
  try {
    const newCard = yield call(createLibraryCardInApi, action.payload);
    yield put(createLibraryCardSuccess(newCard));
  } catch (error) {
    console.error("Error creating LibraryCard:", error);
    yield put(createLibraryCardFailure(error));
  }
}

// Saga to handle updating a LibraryCard
function* updateLibraryCardSaga(action) {
  try {
    console.log(
      `PMM - SF - libraryCardSaga.js - action is: ${JSON.stringify(action)}`
    );
    const updatedCard = yield call(updateLibraryCardInApi, action.payload);
    yield put(updateLibraryCardSuccess(updatedCard));
  } catch (error) {
    console.error("Error updating LibraryCard:", error);
    // Extract error message to avoid non-serializable error object
    const errorMessage = error?.message || error?.toString() || "Unknown error";
    yield put(updateLibraryCardFailure(errorMessage));
  }
}

// Saga to handle deleting a LibraryCard
function* deleteLibraryCardSaga(action) {
  try {
    const response = yield call(deleteLibraryCardFromApi, action.payload);
    yield put(deleteLibraryCardSuccess(response));
  } catch (error) {
    console.error("Error deleting LibraryCard:", error);
    yield put(deleteLibraryCardFailure(error));
  }
}

function* getLibraryCardTagsSaga(action) {
  try {
    const response = yield call(getLibraryCardTagsApi, action.payload);

    if (response?.data?.getLibraryCardIndexTags?.tags) {
      yield put(
        getLibraryCardTagsSuccess(response.data.getLibraryCardIndexTags.tags)
      );
    } else {
      yield put(getLibraryCardTagsFailure("No tags found"));
    }
  } catch (e) {
    yield put(getLibraryCardTagsFailure(e.message));
  }
}

// Saga to handle fetching presigned URLs
function* getPresignedUrlsSaga(action) {
  try {
    const urls = yield call(fetchPresignedUrlsFromApi, action.payload);
    yield put(presignedUrlSuccess(urls));
  } catch (error) {
    console.error("Error fetching presigned URLs:", error);
    yield put(presignedUrlFailure(error));
  }
}

// Saga to handle uploading files
function* uploadFileSaga(action) {
  try {
    const response = yield call(uploadFileToApi, action.payload);
    yield put(uploadFileSuccess(response));
  } catch (error) {
    console.error("Error uploading file:", error);
    yield put(uploadFileFailure(error));
  }
}

// Saga to handle fetching metadata for a LibraryCard
function* fetchMetadataSaga(action) {
  try {
    const metadata = yield call(fetchMetadataFromApi, action.payload);
    yield put(fetchMetadataSuccess(metadata));
  } catch (error) {
    console.error("Error fetching metadata:", error);
    yield put(fetchMetadataFailure(error));
  }
}

// Saga to handle listing LibraryCards
function* listLibraryCardsSaga(action) {
  try {
    console.log(
      `PMM - SF - libraryCardSaga.js - listLibraryCardsSaga - action is: ${JSON.stringify(
        action
      )}`
    );
    const cards = yield call(listLibraryCardsFromApi, action.payload);
    yield put(listCardsSuccess(cards));
  } catch (error) {
    console.error("Error listing LibraryCards:", error);
    yield put(listCardsFailure(error));
  }
}

// Saga to handle fetching details for a specific LibraryCard
function* fetchCardDetailsSaga(action) {
  try {
    console.log(
      `PMM - SF - libraryCardSaga.js - fetchCardDetailsSata - action is: ${JSON.stringify(
        action
      )}`
    );
    const cardDetails = yield call(
      fetchLibraryCardDetailsFromApi,
      action.payload
    );
    console.log(
      `PMM - SF - libraryCardSaga.js - fetchCardDetailsSata - cardDetails is: ${JSON.stringify(
        cardDetails
      )}`
    );
    yield put(fetchCardDetailsSuccess(cardDetails));
  } catch (error) {
    console.error("Error fetching LibraryCard details:", error);
    yield put(fetchCardDetailsFailure(error));
  }
}

function* getLibraryCardSaga(action) {
  console.log(
    `PMM - SF - libraryCardSaga.js - getLibraryCardSaga - action is: ${JSON.stringify(
      action
    )}`
  );
  try {
    const cardDetails = yield call(
      fetchLibraryCardDetailsFromApi,
      action.payload
    );
    console.log(
      `PMM - SF - libraryCardSaga.js - returned cardDetails is: ${JSON.stringify(
        cardDetails
      )}`
    );
    console.log(
      `PMM - SF - libraryCardSaga.js - cardDetails type: ${typeof cardDetails}`
    );
    console.log(
      `PMM - SF - libraryCardSaga.js - cardDetails is null/undefined: ${
        cardDetails == null
      }`
    );
    yield put(fetchCardDetailsSuccess(cardDetails));
  } catch (error) {
    console.error("Error fetching LibraryCard details:", error);
    yield put(fetchCardDetailsFailure(error));
  }
}

// Saga to handle listing entity-specific cards.
// Accepts optional payload.tenantId override (e.g. "system" for fleet-wide rows like COSTROLLUP).
function* listEntityCardsSaga(action) {
  try {
    console.log(`listEntityCardsSaga - action: ${JSON.stringify(action)}`);
    const { entityType, tenantId: tenantOverride } = action.payload;
    const payload = {
      operationType: "LIST_LIBRARY_CARDS",
      tenantId: tenantOverride || getTenantId(),
      entityType: entityType,
    };
    console.log(
      `listEntityCardsSaga - Calling API with payload: ${JSON.stringify(
        payload
      )}`
    );
    const cards = yield call(listLibraryCardsFromApi, payload);
    console.log(
      `listEntityCardsSaga - entityType: ${entityType}, raw API response:`,
      cards
    );
    const pageNames = cards?.pageNames || cards || [];
    console.log(
      `listEntityCardsSaga - Extracted pageNames (${pageNames.length} items):`,
      pageNames
    );
    yield put(listEntityCardsSuccess(entityType, cards));
  } catch (error) {
    console.error("Error listing entity cards:", error);
    // Extract error message to avoid non-serializable error object in Redux
    const errorMessage = error?.message || error?.toString() || "Unknown error";
    yield put(listEntityCardsFailure(action.payload.entityType, errorMessage));
  }
}

// Watcher Saga for LibraryCard actions
function* watchLibraryCardActions() {
  yield takeEvery(FETCH_LIBRARY_CARDS_REQUEST, fetchLibraryCardsSaga);
  yield takeEvery(CREATE_LIBRARY_CARD_REQUEST, createLibraryCardSaga);
  yield takeEvery(UPDATE_LIBRARY_CARD_REQUEST, updateLibraryCardSaga);
  yield takeEvery(DELETE_LIBRARY_CARD_REQUEST, deleteLibraryCardSaga);
  yield takeEvery(REQUEST_PRESIGNED_URL, getPresignedUrlsSaga);
  yield takeEvery(UPLOAD_FILE_REQUEST, uploadFileSaga);
  yield takeEvery(FETCH_METADATA_REQUEST, fetchMetadataSaga);
  yield takeEvery(LIST_CARDS_REQUEST, listLibraryCardsSaga);
  yield takeEvery(FETCH_CARD_DETAILS_REQUEST, fetchCardDetailsSaga);
  yield takeEvery(GET_LIBRARY_CARD_TAGS_REQUEST, getLibraryCardTagsSaga);
  yield takeEvery(GET_LIBRARY_CARD_REQUEST, getLibraryCardSaga);
  yield takeEvery(LIST_ENTITY_CARDS_REQUEST, listEntityCardsSaga);
}

export default watchLibraryCardActions;
